export const folderSelectionMessages = {
  "folderSelection.language.ariaLabel": "Language",

  "folderSelection.logoAlt": "CodeNomad logo",
  "folderSelection.tagline": "Select a folder to start coding with AI",

  "folderSelection.links.github": "CodeNomad GitHub",
  "folderSelection.links.githubStars": "CodeNomad GitHub Stars",
  "folderSelection.links.discord": "CodeNomad Discord",

  "folderSelection.empty.title": "No Recent Folders",
  "folderSelection.empty.description": "Browse for a folder to get started",

  "folderSelection.recent.title": "Recent Folders",
  "folderSelection.recent.subtitle.one": "{count} folder available",
  "folderSelection.recent.subtitle.other": "{count} folders available",
  "folderSelection.recent.rename": "Rename workspace",
  "folderSelection.recent.remove": "Remove from recent",
  "folderSelection.recent.openBadge": "Open",
  "newInstanceLauncher.title": "New instance",
  "newInstanceLauncher.description": "Open a recent project or start a new one.",
  "newInstanceLauncher.searchLabel": "Search recent projects",
  "newInstanceLauncher.searchPlaceholder": "Search recent projects…",
  "newInstanceLauncher.recentTitle": "Recent",
  "newInstanceLauncher.empty": "No recent projects yet.",
  "newInstanceLauncher.noMatch": "No project matches.",
  "newInstanceLauncher.openBadge": "open",
  "newInstanceLauncher.browse": "Browse…",
  "newInstanceLauncher.temporary": "Temporary",
  "newInstanceLauncher.clone": "Clone…",
  "folderSelection.recent.openNewInstance": "Open new instance",
  "folderSelection.recent.switchToOpenProject": "Switch to open project",

  "folderSelection.browse.title": "Browse for Folder",
  "folderSelection.browse.subtitle": "Select any folder on your computer",
  "folderSelection.browse.button": "Browse Folders",
  "folderSelection.browse.buttonOpening": "Opening...",
  "folderSelection.clone.button": "Clone Git Repo",
  "folderSelection.temporary.button": "New temporary instance",
  "folderSelection.temporary.description": "Start in an empty folder managed by CodeNomad; keep or discard it when you close the tab",
  "folderSelection.clone.destination.title": "Select Clone Destination",
  "folderSelection.clone.destination.description": "Select the folder where the repository should be cloned.",
  "folderSelection.clone.dialog.title": "Clone Git Repository",
  "folderSelection.clone.dialog.description": "Clone a Git repository into a local folder, then open it as your workspace.",
  "folderSelection.clone.dialog.repositoryUrl": "Repository URL",
  "folderSelection.clone.dialog.repositoryUrlPlaceholder": "https://github.com/user/repo.git",
  "folderSelection.clone.dialog.destinationPath": "Destination folder",
  "folderSelection.clone.dialog.destinationPathPlaceholder": "Select or enter a destination folder",
  "folderSelection.clone.dialog.browseDestination": "Browse",
  "folderSelection.clone.dialog.cleanupDestination": "Remove the destination folder first if it already exists.",
  "folderSelection.clone.dialog.cancel": "Cancel",
  "folderSelection.clone.dialog.clone": "Clone",
  "folderSelection.clone.dialog.cloning": "Cloning...",
  "folderSelection.clone.dialog.errorRequired": "Repository URL and destination folder are required.",
  "folderSelection.actions.connectButton": "Connect CodeNomad Server",

  "folderSelection.advancedSettings": "Advanced Settings",
  "folderSelection.opencode": "OpenCode",

  "folderSelection.hints.navigate": "Navigate",
  "folderSelection.hints.select": "Select",
  "folderSelection.hints.remove": "Remove",
  "folderSelection.hints.browse": "Browse",

  "folderSelection.loading.title": "Starting instance...",
  "folderSelection.loading.subtitle": "Hang tight while we prepare your workspace.",

  "folderSelection.drop.title": "Drop a folder to open it",
  "folderSelection.drop.subtitle": "Start a new instance in the dropped folder.",
  "folderSelection.drop.invalidTitle": "Couldn't open dropped item",
  "folderSelection.drop.invalidMessage": "Drop a folder to start a new instance.",

  "folderSelection.dialog.title": "Select Workspace",
  "folderSelection.dialog.description": "Select workspace to start coding.",

  "folderSelection.tabs.local": "Local Folders",
  "folderSelection.tabs.servers": "Servers",
  "folderSelection.servers.title": "Saved Servers",
  "folderSelection.servers.subtitle": "Open a saved remote CodeNomad server in a new window",
  "folderSelection.servers.count": "{count} Servers",
  "folderSelection.servers.empty.title": "No Saved Servers",
  "folderSelection.servers.empty.description": "Add a remote server to reconnect quickly from this device",
  "folderSelection.servers.connectTitle": "Connect to Server",
  "folderSelection.servers.connectSubtitle": "Save a remote CodeNomad server and open it in a new window",
  "folderSelection.servers.connectButton": "Connect to Server",
  "folderSelection.servers.remove": "Remove saved server",
  "folderSelection.servers.skipTls": "Self-signed TLS",
  "folderSelection.servers.errorTitle": "Remote Connection Failed",
  "folderSelection.servers.dialog.title": "Connect to Server",
  "folderSelection.servers.dialog.description": "Add a remote CodeNomad server and optionally open it right away.",
  "folderSelection.servers.dialog.name": "Server name",
  "folderSelection.servers.dialog.namePlaceholder": "Production Server",
  "folderSelection.servers.dialog.url": "Server URL",
  "folderSelection.servers.dialog.urlPlaceholder": "https://server.example.com",
  "folderSelection.servers.dialog.urlHint": "A server address, or a Remote Control pairing link created on that computer.",
  "folderSelection.servers.dialog.skipTls": "Skip TLS verification for self-signed certificates.",
  "folderSelection.servers.dialog.cancel": "Cancel",
  "folderSelection.servers.dialog.save": "Save",
  "folderSelection.servers.dialog.connect": "Connect",
  "folderSelection.servers.dialog.connecting": "Connecting...",
  "folderSelection.servers.dialog.errorRequired": "Server name and URL are required.",
  "folderSelection.servers.dialog.errorConnect": "Could not connect to the remote server.",
  "folderSelection.servers.certificateInstall.title": "Install Local Certificate",
  "folderSelection.servers.certificateInstall.confirmMessage": "CodeNomad needs to install a local certificate to open self-signed HTTPS remote windows. This certificate is only used for local desktop proxy traffic on your machine. Your operating system may show a second certificate prompt after this.",
  "folderSelection.servers.certificateInstall.confirmLabel": "Continue",
  "folderSelection.servers.certificateInstall.cancelLabel": "Cancel",
  "folderSelection.servers.certificateInstall.cancelled": "CodeNomad needs the local certificate to be trusted before it can open self-signed HTTPS remote windows.",
  "folderSelection.sidecars.button": "Open SideCar",

  "projectRenameDialog.title": "Rename workspace",
  "projectRenameDialog.description.withLabel": "Update the workspace name for \"{label}\".",
  "projectRenameDialog.description.default": "Set a workspace name for this folder.",
  "projectRenameDialog.input.label": "Workspace name",
  "projectRenameDialog.input.placeholder": "Enter workspace name",
  "projectRenameDialog.actions.cancel": "Cancel",
  "projectRenameDialog.actions.rename": "Rename",
  "projectRenameDialog.actions.renaming": "Renaming...",
} as const
